import { gql } from '@apollo/client';

export * from './assets.query.generated';

export const ASSETS = gql`
  query assets(
    $page: Int
    $softwareEscrowId: ID!
    $perPage: Int
    $queryFilter: String
    $order: QueryOrderEnum
    $orderBy: AssetsOrderByEnum
    $contentType: AssetContentTypeEnum
    $labeled: Boolean
    $ids: [ID!]
    $syncStatuses: [SyncStatusEnum!]
    $depositStatus: DepositStatusEnum
  ) {
    assets(
      page: $page
      perPage: $perPage
      queryFilter: $queryFilter
      order: $order
      orderBy: $orderBy
      softwareEscrowId: $softwareEscrowId
      contentType: $contentType
      labeled: $labeled
      ids: $ids
      syncStatuses: $syncStatuses
      depositStatus: $depositStatus
    ) {
      hasNextPage
      nodes {
        createdAt
        depositSource
        depositStatus
        id
        integration {
          id
          provider
        }
        latestDeposit
        lastUpdateCheck
        syncStatus
        type
        updatedAt
        softwareEscrow {
          id
          depositor {
            companyName
          }
          beneficiary {
            companyName
          }
        }
        error
        size
        policy {
          remove
          update
        }
        contentType
      }
      hasPreviousPage
      nodesCount
      pagesCount
    }
  }
`;
